module.exports = __webpack_public_path__ + "img/tetra@2x.ec71c76f.webp";